
import { useState, createContext, useEffect } from 'react';
import utilsRestMenus from '../Connections/_Utils/utilsRestMenus';

export const RestMenuContext = createContext();

export const RestMenuContextProvider = (props) => {

    const [restMenu, setRestMenu] = useState();

    useEffect(() => {
        if (restMenu) {
        }
        else { getMenu(); }
    }, []);


    const getMenu = async () => {
        let theMenu = await utilsRestMenus.getRestMenu();
        setRestMenu(theMenu)

    }


    return (
        <RestMenuContext.Provider value={[restMenu, setRestMenu,getMenu]}>
            {props.children}
        </RestMenuContext.Provider>
    );
};
